import React, { useEffect, useState, useRef } from "react";
import List from "./repairClaimFirst";
import Utils from "../../utility";
import { getOverrideClaimList } from "../../services/zbrainConnectorService";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

const RepairFirstComponent = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const pageSize = 50;
  const [totalDoc, setTotalDoc] = useState(0);
  const totalPages = Math.ceil(totalDoc / pageSize);
  const [currentPage, setCurrentPage] = useState(
    Number(queryParams.get("page")) || 1
  );
  const [debounce, setDebouncedSearch] = useState(
    queryParams.get("search") || ""
  );
  const topRef = useRef(null);

  const [createdOnSortBy, setCreatedOnSortBy] = useState(
    queryParams.get("createdOnSort") || "desc"
  );
  const [processedOnSortBy, setProcessedOnSortBy] = useState(
    queryParams.get("processedOnSort") || "desc"
  );

  const [date, setDate] = useState({
    startDate: queryParams.get("fromDate") || null,
    endDate: queryParams.get("toDate") || null
  });
  const [modifiedDate, setModifiedDate] = useState({
    startDate: queryParams.get("modifiedFromDate") || null,
    endDate: queryParams.get("modifiedToDate") || null
  });
  const [selectTime, setSelectTime] = useState(
    queryParams.get("selectTime") || "All"
  );
  const [processedDate, setProcessedDate] = useState({
    startDate: queryParams.get("processedOnFrom") || null,
    endDate: queryParams.get("processedOnTo") || null
  });

  const [filterBy, setFilterBy] = useState(
    queryParams.get("filterBy") || "processedDate"
  );

  const [selectProcessedTime, setSelectProcessedTime] = useState(
    queryParams.get("processedTime") || "Last 14 days"
  );
  const [selectModifiedTime, setSelectModifiedTime] = useState(
    queryParams.get("modifiedTime") || "All"
  );
  const [resultFilter, setResultFilter] = useState(
    queryParams.get("claimStatus") || "All"
  );
  const [withinSLA, setWithinSLA] = useState(
    queryParams.get("withinSLA") || "All"
  );

  const [stp, setSTP] = useState(queryParams.get("queueType") || "All");
  const [sort, setSort] = useState(queryParams.get("sort") || "DESC");

  const controllerRef = useRef(null);

  const getDateRange = (label) => {
    const now = new Date();
    switch (label) {
      case "Last 14 days":
        return {
          startDate: Utils.formatDateYear(
            new Date(now - 13 * 24 * 60 * 60 * 1000)
          ),
          endDate: Utils.formatDateYear(now)
        };
      case "Previous month": {
        const firstDayOfMonth = new Date(
          now.getFullYear(),
          now.getMonth() - 1,
          1
        );
        const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 0);
        return {
          startDate: Utils.formatDateYear(firstDayOfMonth),
          endDate: Utils.formatDateYear(lastDayOfMonth)
        };
      }

      default:
        return null;
    }
  };

  const getClaims = async () => {
    if (controllerRef.current) {
      controllerRef.current.abort(); // cancel previous request
    }
    controllerRef.current = new AbortController();
    try {
      let requesData = {
        limit: pageSize,
        offset: (pageSize * (currentPage - 1)) % 10,
        reportType: "list",
        filterBy
      };

      if (debounce) {
        requesData.claimNumber = debounce;
      }
      if (sort && createdOnSortBy) {
        requesData.sortBy = sort;
        requesData.sortOrder = createdOnSortBy;
      }
      if (
        selectTime !== "Custom" &&
        selectTime !== "All" &&
        filterBy === "createdDate"
      ) {
        const { startDate, endDate } = getDateRange(selectTime);
        requesData.startDate = startDate;
        requesData.endDate = endDate;
      }
      if (
        selectModifiedTime !== "Custom" &&
        selectModifiedTime !== "All" &&
        filterBy === "modifiedDate"
      ) {
        const { startDate, endDate } = getDateRange(selectModifiedTime);
        requesData.startDate = startDate;
        requesData.endDate = endDate;
      }
      if (
        date.startDate &&
        date.endDate &&
        selectTime === "Custom" &&
        filterBy === "createdDate"
      ) {
        requesData.startDate = date.startDate;
        requesData.endDate = date.endDate;
      }
      if (
        modifiedDate.startDate &&
        modifiedDate.endDate &&
        selectModifiedTime === "Custom" &&
        filterBy === "modifiedDate"
      ) {
        requesData.startDate = modifiedDate.startDate;
        requesData.endDate = modifiedDate.endDate;
      }
      if (
        selectProcessedTime !== "Custom" &&
        selectProcessedTime !== "All" &&
        filterBy === "processedDate"
      ) {
        const { startDate, endDate } = getDateRange(selectProcessedTime);
        requesData.startDate = startDate;
        requesData.endDate = endDate;
      }

      if (
        processedDate.startDate &&
        processedDate.endDate &&
        selectProcessedTime === "Custom" &&
        filterBy === "processedDate"
      ) {
        requesData.startDate = processedDate.startDate;
        requesData.endDate = processedDate.endDate;
      }

      if (withinSLA !== "All") {
        requesData.withinSla = withinSLA === "Yes" ? true : false;
      }
      if (stp !== "All") {
        requesData.queueType = stp;
      }
      if (resultFilter !== "All") {
        requesData.claimStatus = resultFilter;
      }

      setLoading(true);
      const signal = controllerRef.current.signal;
      const [error, response] = await Utils.parseResponse(
        getOverrideClaimList(requesData, signal)
      );

      if (error || !response) {
        if (error?.response?.status === 500) {
          toast.error("Internal server error");
        } else {
          toast.error(error?.response?.data?.message);
        }
        return;
      }

      setTotalDoc(response?.data?.totalCount);

      setList(response?.data?.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      scrollToTop();
    }
  };
  const handleFirstPage = () => {
    handlePageChange(1);
    scrollToTop();
  };

  const handleLastPage = () => {
    handlePageChange(totalPages);
    scrollToTop();
  };

  const updateQueryParams = (key, value) => {
    if (value) {
      queryParams.set(key, value);
    } else {
      queryParams.delete(key);
    }
  };

  const updateDateParams = () => {
    if (
      date?.endDate !== null &&
      date?.startDate !== null &&
      selectTime === "Custom"
    ) {
      queryParams.set("fromDate", date.startDate);
      queryParams.set("toDate", date.endDate);
    } else {
      queryParams.delete("toDate");
      queryParams.delete("fromDate");
    }
  };
  const updateProcessedParams = () => {
    if (
      processedDate?.endDate !== null &&
      processedDate?.startDate !== null &&
      selectProcessedTime === "Custom"
    ) {
      queryParams.set("processedOnFrom", processedDate.startDate);
      queryParams.set("processedOnTo", processedDate.endDate);
    } else {
      queryParams.delete("processedOnTo");
      queryParams.delete("processedOnFrom");
    }
  };

  const updateModifiedParams = () => {
    if (
      modifiedDate?.endDate !== null &&
      modifiedDate?.startDate !== null &&
      selectModifiedTime === "Custom"
    ) {
      queryParams.set("modifiedFromDate", modifiedDate.startDate);
      queryParams.set("modifiedToDate", modifiedDate.endDate);
    } else {
      queryParams.delete("modifiedFromDate");
      queryParams.delete("modifiedToDate");
    }
  };

  useEffect(() => {
    if (
      (selectProcessedTime === "Custom" &&
        processedDate.endDate &&
        processedDate.startDate) ||
      selectProcessedTime !== "Custom"
    ) {
      getClaims();
    }

    updateQueryParams("page", currentPage);

    updateDateParams();
    queryParams.set("selectTime", selectTime);
    updateModifiedParams();
    queryParams.set("modifiedSelectTime", selectModifiedTime);
    updateProcessedParams();
    queryParams.set("processedTime", selectProcessedTime);
    queryParams.set("processedOnSort", processedOnSortBy);
    queryParams.set("createdOnSort", createdOnSortBy);
    queryParams.set("queueType", stp);
    queryParams.set("withinSLA", withinSLA);
    queryParams.set("claimStatus", resultFilter);
    queryParams.set("sort", sort);
    if (debounce) {
      queryParams.set("search", debounce);
    } else {
      queryParams.delete("search");
    }

    navigate(
      {
        search: queryParams.toString()
      },
      { replace: true }
    );
    // eslint-disable-next-line
  }, [
    debounce,
    currentPage,
    selectTime,
    date,
    createdOnSortBy,
    selectProcessedTime,
    processedDate,
    processedOnSortBy,
    stp,
    resultFilter,
    withinSLA,
    sort,
    modifiedDate,
    selectModifiedTime
  ]);

  useEffect(() => {
    const savedScrollPosition = sessionStorage.getItem("scrollPosition");
    if (savedScrollPosition && topRef.current) {
      topRef.current.scrollTo(0, parseInt(savedScrollPosition, 10));
    }
  });

  return (
    <div className="h-full">
      <List
        loading={loading}
        list={list}
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        handleFirstPage={handleFirstPage}
        handleLastPage={handleLastPage}
        setDebouncedSearch={setDebouncedSearch}
        debounce={debounce}
        setDate={setDate}
        date={date}
        setSelectTime={setSelectTime}
        selectTime={selectTime}
        setCreatedOnSortBy={setCreatedOnSortBy}
        createdOnSortBy={createdOnSortBy}
        setProcessedOnSortBy={setProcessedOnSortBy}
        processedOnSortBy={processedOnSortBy}
        topRef={topRef}
        setCurrentPage={setCurrentPage}
        processedDate={processedDate}
        setProcessedDate={setProcessedDate}
        selectProcessedTime={selectProcessedTime}
        setSelectProcessedTime={setSelectProcessedTime}
        setResultFilter={setResultFilter}
        resultFilter={resultFilter}
        withinSLA={withinSLA}
        setWithinSLA={setWithinSLA}
        stp={stp}
        setSTP={setSTP}
        sort={sort}
        setSort={setSort}
        setFilterBy={setFilterBy}
        filterBy={filterBy}
        setSelectModifiedTime={setSelectModifiedTime}
        setModifiedDate={setModifiedDate}
        selectModifiedTime={selectModifiedTime}
        modifiedDate={modifiedDate}
      />
    </div>
  );
};

export default RepairFirstComponent;
